// Close button and label on mobile subnavigation
jQuery(function() {
    jQuery("li.sub-menu-close, .dol-subnav-wrapper label").click(function () {
      if (jQuery(window).outerWidth() <= 767) {
        jQuery(".dol-subnav-wrapper").toggleClass("sidebar-is-closed");
        jQuery(".dol-subnav-wrapper").toggleClass("sidebar-is-open");
        jQuery("#page-title-area").toggleClass("sidebar-is-closed");
        jQuery("#page-title-area").toggleClass("sidebar-is-open");
        jQuery(".layout-content").toggleClass("sidebar-is-closed");
        jQuery(".layout-content").toggleClass("sidebar-is-open");
      }
    });
    jQuery(".dol-subnav-wrapper li.sub-menu-close a").click(function(e) {
      e.preventDefault();
    });
});
// Shows full subnavigation over 768px window width
jQuery(function() {
  if(jQuery(window).outerWidth() >= 768) {
    jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-closed');
    jQuery('.dol-subnav-wrapper').addClass('sidebar-is-open');
  }
  else {
    jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-open');
    jQuery('.dol-subnav-wrapper').addClass('sidebar-is-closed');
  }
  jQuery(window).on('resize', function(){
      if(jQuery(window).outerWidth() > 767) {
          jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-closed');
          jQuery('.dol-subnav-wrapper').addClass('sidebar-is-open');
          jQuery('#page-title-area').removeClass('sidebar-is-open');
          jQuery('.layout-content').removeClass('sidebar-is-open');
      }
      else {
          jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-open');
          jQuery('.dol-subnav-wrapper').addClass('sidebar-is-closed');
          jQuery('#page-title-area').removeClass('sidebar-is-open');
          jQuery('.layout-content').removeClass('sidebar-is-open');
      }
  });
  jQuery('.dol-sidebar').click(function(event) {
    event.stopPropagation();
  });
});

// Assigns active class to current page's link in subnavigation
jQuery(document).ready(function() {
  var pathname = window.location.pathname;
  jQuery('ul.usa-sidenav li a[href="'+pathname+'"]').addClass('usa-current');
});

// Adds bootstrap class for sidebar
jQuery(document).ready(function () {
  if (jQuery('.cd-main-content').find('.dol-subnav-wrapper').length > 0) {
      jQuery('.cd-main-content').addClass('active-book-page');
  }
  if (jQuery('.cd-main-content').find('.groups-sidebar').length > 0) {
      jQuery('.cd-main-content').addClass('groups-sidebar');
  }
});
